module.exports = __webpack_public_path__ + "static/media/question-mark.1ca5940c.svg";